// Cookie / tracking consent state, persisted in localStorage. The banner
// component drives the user choice; analytics init reads it before booting
// PostHog so declined visitors never load a tracking cookie at all.

const KEY = 'consent.analytics';

export type ConsentChoice = 'accepted' | 'declined';

type Listener = (choice: ConsentChoice | null) => void;
const listeners = new Set<Listener>();

export function getConsent(): ConsentChoice | null {
  if (typeof window === 'undefined') return null;
  const value = window.localStorage.getItem(KEY);
  if (value === 'accepted' || value === 'declined') return value;
  return null;
}

export function setConsent(choice: ConsentChoice): void {
  window.localStorage.setItem(KEY, choice);
  for (const fn of listeners) fn(choice);
}

export function onConsentChange(fn: Listener): () => void {
  listeners.add(fn);
  return () => {
    listeners.delete(fn);
  };
}
